<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="participant-resources">
                <b-row>
                    <b-col ref="my-resources">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="document"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_RESOURCES') }}
                                    <print-button content="my-resources" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body>

                                <h4>{{ $i18n.gt('LABEL_RESOURCES') }}</h4>
                                <div v-if="!planOptions.length" class="mb-3">
                                    {{ $i18n.gt('LABEL_RESOURCES_NONE') }}
                                </div>
                                <div v-else>
                                    <ul>
                                        <li v-for="(option, i) in planOptions" :key="i">
                                            {{ option.value }}
                                        </li>
                                    </ul>
                                </div>

                                <h4>{{ $i18n.gt('HEADING_HANDOUTS') }}</h4>
                                <div v-if="!handouts.length" class="mb-3">
                                    {{ $i18n.gt('LABEL_NO_HANDOUTS_RECOMMENDED') }}
                                </div>
                                <div v-else>
                                    <ul>
                                        <li v-for="(handout, i) in handouts" :key="i">
                                            <handout-download-link :handout="handout">
                                            </handout-download-link>
                                        </li>
                                    </ul>
                                </div>

                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>

            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import PatientPageMixin from "@/providers/PatientPageMixin"
import PrintButton from '@/components/PrintButton'

/**
 * Page to manage a Participant's wellness resources
 */
export default Vue.extend({
    name: 'ParticipantResources',
    components: { PrintButton },
    mixins: [PatientPageMixin],
    computed: {
        path() {
            return this.participant.wellness_plan.path
        },
        handouts() {
            return _.uniqBy(
                _.flatten(
                    _.map(this.participant.surveyNotes, (sn) => {
                        return _.filter(sn.handouts, (handout) => {
                            return handout.checked
                        })
                    })
                ),
                (handout) => handout.pdf
            )
        },
        planOptions() {
            return _.uniqBy(
                _.flatten(
                    _.map(this.participant.surveyNotes, (sn) => {
                        return _.filter(sn.plan_options, (option) => {
                            // option format: {"value":"Visiting Nurse Service","checked":false, ...}
                            return option.checked
                        })
                    })
                ),
                (option) => option.value
            )
        }
    }
})

</script>

<style lang="scss">
.participant-resources {
    .print-button {
        float: right;
        margin-top: .2em;
    }
}
</style>
